import { Link } from "react-router-dom";
import { HIPAA } from "@/assets/images";
import { infoBannerLinks } from "@/constants";

const InfoBanner = () => {
  return (
    <div className="p-[12px_24px_8px_16px] gap-6 font-normal flex items-center justify-center text-white">
      <img src={HIPAA} alt="HIPAA compliant" className="w-[105px]" />
      {/* <div className="text-sm flex flex-col leading-tight">
        <p>Your Information Is </p>
        {infoBannerLinks.map(({ name, path }) => (
          <Link
            key={name}
            to={path}
            className="cursor-pointer underline decoration-1"
          >
            {name}
          </Link>
        ))}
      </div> */}
    </div>
  );
};

export default InfoBanner;
